import { BillingPortalProps } from "../app/models/BillingPortalProps";
export const environment = {
    production: false,
    token: "Initial Token",
    customerID: "",
    fallbackEnable : false,
    serverURL: "https://api-pr.brightspeed.com/",
    apigeeServerURL: "http://apigee-service-pr.billing-pr.svc.cluster.local:8080/",
    brimURI: "bp-brim/",
    apigeeURI: "apigee/v1/",
    //apigeeURI: "bp-apigee/",
    speedpaySSOURL: "https://internet.speedpay.com/api/brightspeed/sso?cid=BrightspeedSSO",
	pgURI: "bp-aci/",
    bsEnabled: true,
    accountNumber : "657893210124",
    serverFURL: "https://billing.brightspeed.com/",
    itemsPerPage : 10,
    auzreAuthDomain : "hub.signin.brightspeed.com",
    azurePrimaryDomain : "brightspeedEWPProdB2C.onmicrosoft.com",
    azureFlowSuffix : "prod",
    billingProps : new BillingPortalProps(),
    aud : "7c034653-e9a0-46bd-ac66-b4e3447a3ed2",
    usageRecordFilter : 6,
    newPaymentExperienceEnableFlag: true,
    PaymentHistoryEnableFlag: true,
    billAnalyticsEnableFlag: true,
    ViewInvoiceEnableFlag: true,
    MakePyamentEnableFlag: true,
    DisputeCreateEnableFlag: true,
    ManagePaymentMethodEnable: true,
    historicalBan: "",
    vktypForTSA: ['ZC', 'ZE', 'ZM'],
    tsaErrorPopupVisibility: false,
    enablePaperlessBilling: false,
    serviceErrorPageVisibility: false,
    systemDownInstructionHeader: "System is down for maintenance!",
    systemDownInstructionText: "The billing system is down for maintenance. Please try again after 24 hours. Sorry for the inconvenience.",
    enableLog: true,
    env: "prod",
    encryptionKey: "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAxTcACW1z9uC9En2iQNOkinSoTlw//MDLMo5eYmTza3MDYipeOXM+MKN0Ud9RkCatT5pK3Gm4OMQ18hV+m81iq+/R4gSiGfSl4mbdzZhBA6iR7/qH4sRkZvbHDmxB99fm5u2ksg2nZigW8+P+rmjDvpUqtL60DzdoMt+IFBp/e7RyPFZcahnNLSlJBU73HpYRMOKQRoaTOFLcq3rXzLM1DOwqyTTA8AFHJLJpZe+Znxj9eUj/r+f5/qgjP+28ksAsMeDNpDF3muENcVOyBbQPY+2YASwR0q1zx9EcAj75nuMHBr5P20A93Y/pxYU8fTOBeAARcA6Z/mkk/jb2fqBjPwIDAQAB",
    fetchBanConfig: "vcid" // value should be "vcid" OR "ban-inclusion"
};
